import * as React from "react";
import { DialogInteractions } from "./useDialogRoot.js";
import { useDialogRootContext, DialogRootContext } from "./DialogRootContext.js";
import { DialogStore } from "../store/DialogStore.js";
import { createChangeEventDetails } from "../../internals/createBaseUIEventDetails.js";
import { jsxs, jsx } from "react/jsx-runtime";
import { usePopupRootStore, usePopupRootSync, useImplicitActiveTrigger, useOpenStateTransitions, PopupHandleAttachment } from "../../utils/popups/popupStoreUtils.js";
import { imperativeAction } from "../../internals/reason-parts.js";
function useRenderDialogRoot(mode, props) {
  const {
    children,
    open: openProp,
    defaultOpen = false,
    onOpenChange,
    onOpenChangeComplete,
    disablePointerDismissal: disablePointerDismissalProp = false,
    modal: modalProp = true,
    actionsRef,
    handle,
    triggerId: triggerIdProp,
    defaultTriggerId: defaultTriggerIdProp = null
  } = props;
  const isDrawer = mode === "drawer";
  const modal = modalProp;
  const disablePointerDismissal = disablePointerDismissalProp;
  const role = "dialog";
  const parentStore = useDialogRootContext(true);
  const nested = parentStore != null;
  const rootState = {
    modal,
    disablePointerDismissal,
    nested,
    role
  };
  const store = usePopupRootStore((floatingId, floatingNested) => new DialogStore({
    open: defaultOpen,
    openProp,
    activeTriggerId: defaultTriggerIdProp,
    triggerIdProp,
    ...rootState
  }, floatingId, floatingNested), true);
  store.useControlledProp("openProp", openProp);
  store.useControlledProp("triggerIdProp", triggerIdProp);
  store.useSyncedValues(rootState);
  store.useContextCallback("onOpenChange", onOpenChange);
  store.useContextCallback("onOpenChangeComplete", onOpenChangeComplete);
  const open = store.useState("open");
  const mounted = store.useState("mounted");
  const payload = store.useState("payload");
  usePopupRootSync(store, open);
  useImplicitActiveTrigger(store);
  const {
    forceUnmount
  } = useOpenStateTransitions(open, store);
  React.useImperativeHandle(actionsRef, () => ({
    unmount: forceUnmount,
    close: () => store.setOpen(false, createChangeEventDetails(imperativeAction))
  }), [forceUnmount, store]);
  const shouldRenderInteractions = open || mounted;
  return /* @__PURE__ */ jsxs(DialogRootContext.Provider, {
    value: store,
    children: [handle && /* @__PURE__ */ jsx(PopupHandleAttachment, {
      handle,
      store
    }), shouldRenderInteractions && /* @__PURE__ */ jsx(DialogInteractions, {
      store,
      parentContext: parentStore?.context,
      isDrawer
    }), typeof children === "function" ? children({
      payload
    }) : children]
  });
}
export {
  useRenderDialogRoot
};
//# sourceMappingURL=useRenderDialogRoot.js.map
